import { Pipe, PipeTransform } from "@angular/core";
import { capitalizeFirstLetter } from "../../utlis/text.util";

@Pipe({
  name: "capitalizeFirst",
})
export class CapitalizeFirstPipe implements PipeTransform {
  transform(value: string): string {
    return capitalizeFirstLetter(value);
  }
}
